export const DH = {
  WidgetContainer: 'bnpl-ooi-widget-container',
};
